import {
  GET_SWAPS, GET_SWAPS_SUCCESS, GET_SWAPS_FAILURE,
} from '../actions/swaps';
import { filterOrders } from '../helpers/swaps';
import { CLEAR_SWAPS_CACHE } from '../actions/account';

const INITIAL_STATE = { loading: true, data: { orders: [] } };

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_SWAPS:
      return { ...state, loading: true };
    case GET_SWAPS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: { ...action.payload, orders: filterOrders(action?.payload.orders) },
        cached: true,
      };
    case GET_SWAPS_FAILURE:
      return { ...state, loading: false, error: true };
    case CLEAR_SWAPS_CACHE:
      return { ...state, cached: false };
    default:
      return state;
  }
}
